import { render, staticRenderFns } from "./WhyChooseUs.vue?vue&type=template&id=4a2275db"
import script from "./WhyChooseUs.vue?vue&type=script&lang=js"
export * from "./WhyChooseUs.vue?vue&type=script&lang=js"
import style0 from "./WhyChooseUs.vue?vue&type=style&index=0&id=4a2275db&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports